"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openAiModelCards = exports.OPEN_AI_MODEL_CARDS = exports.OpenAiModel = void 0;
exports.getOpenAiModelCard = getOpenAiModelCard;
exports.supportsOpenAiReasoningEffort = supportsOpenAiReasoningEffort;
const model_card_1 = require("./model-card");
var OpenAiModel;
(function (OpenAiModel) {
    OpenAiModel["gpt_5_6_sol"] = "gpt-5.6-sol";
    OpenAiModel["gpt_5_6_terra"] = "gpt-5.6-terra";
    OpenAiModel["gpt_5_6_luna"] = "gpt-5.6-luna";
    OpenAiModel["gpt_5_4"] = "gpt-5.4";
    OpenAiModel["gpt_5_2"] = "gpt-5.2";
    OpenAiModel["gpt_5_1"] = "gpt-5.1";
    OpenAiModel["gpt_5_mini"] = "gpt-5-mini";
    OpenAiModel["gpt_5_nano"] = "gpt-5-nano";
    OpenAiModel["gpt_4_1"] = "gpt-4.1";
})(OpenAiModel || (exports.OpenAiModel = OpenAiModel = {}));
const REASONING_EFFORT_PARAMETER = 'reasoning.effort';
function reasoning({ default: defaultValue }, ...supportedValues) {
    return {
        parameter: REASONING_EFFORT_PARAMETER,
        supportedValues,
        defaultValue,
    };
}
function pricing(input, output) {
    return {
        currency: 'USD',
        unit: 'perMillionTokens',
        input,
        output,
    };
}
exports.OPEN_AI_MODEL_CARDS = {
    [OpenAiModel.gpt_5_6_sol]: {
        model: OpenAiModel.gpt_5_6_sol,
        name: 'GPT-5.6 Sol',
        provider: model_card_1.AiModelProvider.openAi,
        reasoning: reasoning({ default: model_card_1.AiModelEffort.medium }, model_card_1.AiModelEffort.none, model_card_1.AiModelEffort.low, model_card_1.AiModelEffort.medium, model_card_1.AiModelEffort.high, model_card_1.AiModelEffort.xhigh, model_card_1.AiModelEffort.max),
        standardTokenPricing: pricing(5, 30),
        contextWindowTokens: 1_050_000,
        maxOutputTokens: 128_000,
    },
    [OpenAiModel.gpt_5_6_terra]: {
        model: OpenAiModel.gpt_5_6_terra,
        name: 'GPT-5.6 Terra',
        provider: model_card_1.AiModelProvider.openAi,
        reasoning: reasoning({ default: model_card_1.AiModelEffort.medium }, model_card_1.AiModelEffort.none, model_card_1.AiModelEffort.low, model_card_1.AiModelEffort.medium, model_card_1.AiModelEffort.high, model_card_1.AiModelEffort.xhigh, model_card_1.AiModelEffort.max),
        standardTokenPricing: pricing(2.5, 15),
        contextWindowTokens: 1_050_000,
        maxOutputTokens: 128_000,
    },
    [OpenAiModel.gpt_5_6_luna]: {
        model: OpenAiModel.gpt_5_6_luna,
        name: 'GPT-5.6 Luna',
        provider: model_card_1.AiModelProvider.openAi,
        reasoning: reasoning({ default: model_card_1.AiModelEffort.medium }, model_card_1.AiModelEffort.none, model_card_1.AiModelEffort.low, model_card_1.AiModelEffort.medium, model_card_1.AiModelEffort.high, model_card_1.AiModelEffort.xhigh, model_card_1.AiModelEffort.max),
        standardTokenPricing: pricing(1, 6),
        contextWindowTokens: 1_050_000,
        maxOutputTokens: 128_000,
    },
    [OpenAiModel.gpt_5_4]: {
        model: OpenAiModel.gpt_5_4,
        name: 'GPT-5.4',
        provider: model_card_1.AiModelProvider.openAi,
        reasoning: reasoning({ default: model_card_1.AiModelEffort.medium }, model_card_1.AiModelEffort.none, model_card_1.AiModelEffort.low, model_card_1.AiModelEffort.medium, model_card_1.AiModelEffort.high, model_card_1.AiModelEffort.xhigh),
        standardTokenPricing: pricing(2.5, 15),
        contextWindowTokens: 1_050_000,
        maxOutputTokens: 128_000,
    },
    [OpenAiModel.gpt_5_2]: {
        model: OpenAiModel.gpt_5_2,
        name: 'GPT-5.2',
        provider: model_card_1.AiModelProvider.openAi,
        reasoning: reasoning({ default: model_card_1.AiModelEffort.medium }, model_card_1.AiModelEffort.none, model_card_1.AiModelEffort.low, model_card_1.AiModelEffort.medium, model_card_1.AiModelEffort.high, model_card_1.AiModelEffort.xhigh),
        standardTokenPricing: pricing(1.75, 14),
        contextWindowTokens: 400_000,
        maxOutputTokens: 128_000,
    },
    [OpenAiModel.gpt_5_1]: {
        model: OpenAiModel.gpt_5_1,
        name: 'GPT-5.1',
        provider: model_card_1.AiModelProvider.openAi,
        reasoning: reasoning({ default: model_card_1.AiModelEffort.medium }, model_card_1.AiModelEffort.none, model_card_1.AiModelEffort.low, model_card_1.AiModelEffort.medium, model_card_1.AiModelEffort.high),
        standardTokenPricing: pricing(1.25, 10),
        contextWindowTokens: 400_000,
        maxOutputTokens: 128_000,
    },
    [OpenAiModel.gpt_5_mini]: {
        model: OpenAiModel.gpt_5_mini,
        name: 'GPT-5 mini',
        provider: model_card_1.AiModelProvider.openAi,
        reasoning: reasoning({ default: model_card_1.AiModelEffort.medium }, model_card_1.AiModelEffort.minimal, model_card_1.AiModelEffort.low, model_card_1.AiModelEffort.medium, model_card_1.AiModelEffort.high),
        standardTokenPricing: pricing(0.25, 2),
        contextWindowTokens: 400_000,
        maxOutputTokens: 128_000,
    },
    [OpenAiModel.gpt_5_nano]: {
        model: OpenAiModel.gpt_5_nano,
        name: 'GPT-5 nano',
        provider: model_card_1.AiModelProvider.openAi,
        reasoning: reasoning({ default: model_card_1.AiModelEffort.medium }, model_card_1.AiModelEffort.minimal, model_card_1.AiModelEffort.low, model_card_1.AiModelEffort.medium, model_card_1.AiModelEffort.high),
        standardTokenPricing: pricing(0.05, 0.4),
        contextWindowTokens: 400_000,
        maxOutputTokens: 128_000,
    },
    [OpenAiModel.gpt_4_1]: {
        model: OpenAiModel.gpt_4_1,
        name: 'GPT-4.1',
        provider: model_card_1.AiModelProvider.openAi,
        reasoning: null,
        standardTokenPricing: pricing(2, 8),
        contextWindowTokens: 1_047_576,
        maxOutputTokens: 32_768,
    },
};
exports.openAiModelCards = Object.values(exports.OPEN_AI_MODEL_CARDS);
function getOpenAiModelCard(model) {
    return exports.OPEN_AI_MODEL_CARDS[model];
}
function supportsOpenAiReasoningEffort(model, effort) {
    return getOpenAiModelCard(model).reasoning?.supportedValues.includes(effort) ?? false;
}
//# sourceMappingURL=open-ai-model-cards.js.map